export default __webpack_public_path__ + "static/media/catlike130000.e2026ae3.png";